export function requiredFieldValidation(value?: string) {
  if (!value) {
    return false;
  }
  return true;
}
